import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import IdleScreen from "../pages/idle";
import QRScanScreen from "../pages/qr-scan";
import MainScreen from "../pages/main";
import MagicScreen from "../pages/magic";
import ColorSelectionScreen from "../pages/color-selection";
import LanternSelectedScreen from "../pages/selected-lantern";
import JoiningTodayScreen from "../pages/joining-today";
import TakeVideo10SecScreen from "../pages/take-video-10s";
import QRCodeForImageUploadScreen from "../pages/qr-code-for-image-upload";
import ChooseAvatarScreen from "../pages/choose-avatar";
import ChooseFriendAvatarScreen from "../pages/choose-firiend-avatar";
import KioskSessionManager from "../compoment/KioskSessionManager";
import GlobalPinHandler from "../compoment/GlobalPinHandler";
import PWAInstallPrompt from "../compoment/PWAInstallPrompt";


const AppRoutes = () => {
  return (
    <Router>
      <KioskSessionManager />
      <GlobalPinHandler />
      <PWAInstallPrompt />
      <Routes>
        {/* ================= COMMON ROUTE ================= */}
        <Route path="/" element={<IdleScreen />} />
        <Route path="/qr-scan" element={<QRScanScreen />} />
        <Route path="/main" element={<MainScreen />} />
        <Route path="/color-selection" element={<ColorSelectionScreen />} />
        <Route path="/selected-lantern" element={<LanternSelectedScreen />} />
        <Route path="/today-joining" element={<JoiningTodayScreen />} />
        <Route path="/choose-avatar" element={<ChooseAvatarScreen />} />
        <Route path="/choose-friend-avatar" element={<ChooseFriendAvatarScreen />} />
        {/* <Route path="/take-10s-video" element={<TakeVideo10SecScreen />} />
        <Route path="/qr-code-for-image-upload" element={<QRCodeForImageUploadScreen />} /> */}
        <Route path="/magic" element={<MagicScreen />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
